import Main from "../components/layout/Main";
import Projects from "../containers/CohortBuilder/Projects/Projects";
import React, {useState} from "react";
import {CohortNavigation} from "../components/cohort-navigation/CohortNavigation";
import {ProjectsPageContext} from "./ProjectsPageContext";

export const ProjectsPage = () => {
    const [classic, setClassic] = useState<boolean>(false)
    return <div>
        <ProjectsPageContext.Provider value={{classic, setClassic}}>
            <Main
                containerClassName="white"
                secondaryNavigation={<CohortNavigation showCohortAnalyserSwitch={false}/>}>
                <Projects/>
            </Main>
        </ProjectsPageContext.Provider>
    </div>
}